import { widgetState } from './index'
import { WidgetCustomizations } from '../../customizations/types'

export const setCustomizations = (customizations: WidgetCustomizations) => {
  widgetState.customizations = customizations
}
